<template>
  <v-container>
    <v-row>

                <!--------------------------------->
                <!--         Page Title          -->
                <!--------------------------------->
      <v-col
        class="text-center mt-4 pa-0"
      >
        <h1>
          Preferences
        </h1>
      </v-col>
    </v-row>
    <v-row
      justify="center"
    >
      <v-col
        xs="12"
        sm="12"
        md="10"
        lg="8"
        xl="6"
      >
        <v-expansion-panels
          hover
          popout
          focusable
        >
        <!--------------------------------------->
        <!--            Set Schedule           -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Schedule
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <SchedulingComponent
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        <!--------------------------------------->
        <!--           Diet Selector           -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Diet
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <DietSelection
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        <!--------------------------------------->
        <!--          Allergy Selector         -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Allergies
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <Allergies
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        <!--------------------------------------->
        <!--    Favorite Food Type Selector    -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Favorite Food Types
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <FoodTypes
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        <!--------------------------------------->
        <!--           Weekly Budget           -->
        <!--------------------------------------->
          <!-- <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Weekly Budget
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <Budget
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel> -->

        </v-expansion-panels>


      <!--           Save           -->
        <v-row
          v-if="!saved"
          class="mt-8 mx-5 pa-0"
        >
          <v-col
            class="text-left ma-0 pa-0"
          >
            <v-btn
              
              color="red"
              class="mt-0 white--text"
              @click.prevent="cancelSavePreferences"
            >
              Cancel
            </v-btn>
          </v-col>
          <v-col
            class="text-right ma-0 pa-0"
          >
            <v-btn
              v-if="!saved"
              color="blue"
              class="white--text"
              @click.prevent="savePreferences"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DietSelection from '@/components/food_preferences/DietSelection.vue'
import Allergies from '@/components/food_preferences/Allergies.vue'
import FoodTypes from '@/components/food_preferences/FoodTypes.vue'
// import Budget from '@/components/food_preferences/Budget.vue'
import SchedulingComponent from '@/components/schedule/SchedulingComponent.vue'


export default {
  beforeCreate() {
    this.$store.dispatch('data/loadPreferences');
  },

  components: {
    DietSelection,
    Allergies,
    FoodTypes,
    // Budget,
    SchedulingComponent
  },

  data: () => ({

  }),

  methods: {
      savePreferences() {
        this.$store.dispatch('data/savedPreferences');
      },
      cancelSavePreferences() {
        this.$store.dispatch('data/loadPreferences');
      }
    },

  computed: {
      saved() {
          return this.$store.getters['data/savedPreferences'];
      },    
  },

  

}
</script>
